import { FC } from "react";
import Link from "next/link";
import styled from "@material-ui/core/styles/styled";

const Root = styled("div")(() => ({
  width: "100%",
  height: "44px",
  position: "relative",
  display: "block",
}));

type Props = {
  slug: string;
  isPreviewMode: boolean;
  isShopping: boolean;
};
export const LinkButtonSp: FC<Props> = (props: Props) => (
  <Link
    href={{
      pathname: `${props.isPreviewMode ? "/admin/preview" : ""}/project/${
        props.slug
      }`,
      hash: "course",
    }}
  >
    <Root>
      <div className="link_upper">
        <div className="link_upper--item" />
        <div className="link_upper--item" />
        <div className="link_upper--item" />
        <div className="link_upper--item" />
        <div className="link_upper--item" />
        <div className="link_upper--item" />
      </div>
      <div className="link_text">
        <p>{props.isShopping ? "購入する商品を選ぶ" : "プロジェクトを応援する"}</p>
      </div>
      <div className="link_lower">
        <div className="link_lower--item" />
        <div className="link_lower--item" />
        <div className="link_lower--item" />
        <div className="link_lower--item" />
        <div className="link_lower--item" />
        <div className="link_lower--item" />
      </div>
    </Root>
  </Link>
);
